<template>
  <transition-group name="slide" tag="div" class="ui-toast-list component">
    <UiToast v-for="item in toastsList" :key="item.id" :item="item" @remove="onRemove" />
  </transition-group>
</template>

<script>
import UiToast from './UiToast'
export default {
  name: 'UiToastList',

  components: {
    UiToast,
  },

  computed: {
    toastsList() {
      return this.$store.state.toast.toastsList
    },
  },

  watch: {
    $route: {
      handler: 'clearToastList',
      deep: 'true',
    },
  },

  methods: {
    onRemove(id) {
      this.$store.commit('toast/REMOVE', { id })
    },
    clearToastList() {
      if (this.toastsList.length) {
        this.$store.commit('toast/CLEAR_LIST')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ui-toast-list.component {
  position: fixed;
  top: 50px;
  right: 50px;
  z-index: 9999;
  width: 300px;
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.3s;
}
.slide-enter {
  transform: translate(0, 100%);
}
.slide-leave-to {
  transform: translate(200%, 0);
}
</style>
